import React from 'react'
import PropTypes from 'prop-types'
import './ShotVirtualContainer.css'
import ImmunizationBoxContainer from '../ImmunizationBox/ImmunizationBoxContainer'
import RecommendationBoxContainer from '../RecommendationBox/RecommendationBoxContainer'
import PlannedShotBoxContainer from '../PlannedShotBox/PlannedShotBoxContainer'
import withPolyglot from '../../../../../common/withPolyglot'
import moment from 'moment'
import RecommendationAdditionBoxContainer from '../RecommendationAdditionBox/RecommendationAdditionBoxContainer'

function getDateForElement (type, data, patientBirth) {
  if (type === 'i') {
    return moment(new Date(data.date))
  } else if (type === 'r') {
    return moment(new Date(data.dateCriterion.recommended))
  } else {
    return moment(new Date(patientBirth)).add(data.val, data.unit)
  }
}
function combineAll (recommendations, immunizations, planned, patientBirthDate) {
  const arr = []
  immunizations.forEach(immunization => {
    arr.push({
      type: 'i',
      data: immunization
    })
  })
  recommendations.forEach(recommendation => {
    arr.push({
      type: 'r',
      data: recommendation
    })
  })
  planned.forEach(plannedShot => {
    arr.push({
      type: 'p',
      data: plannedShot
    })
  })
  arr.sort((a, b) => {
    const dateA = getDateForElement(a.type, a.data, patientBirthDate)
    const dateB = getDateForElement(b.type, b.data, patientBirthDate)
    if (dateA.isBefore(dateB)) {
      return -1
    } else if (dateA.isAfter(dateB)) {
      return 1
    } else {
      return 0
    }
  })
  return arr
}

const ShotVirtualContainer = ({editMode, immunizations, recommendations, planned, translate, patientBirthDate}) => {
  const elements = combineAll(recommendations, immunizations, planned, patientBirthDate)
  return <div>
    <hr className='no-margin-hr' />
    {elements.length
      ? <div
        className='uk-grid virtual-container-grid uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-child-width-1-6@l'
        data-uk-grid>
        {
          elements.map(({type, data}, index) => {
            if (type === 'i') {
              return <div className={`grid-cell ${editMode ? 'no-shadow faded' : ''}`} key={index}>
                <ImmunizationBoxContainer
                  clickDisabled={editMode}
                  immunization={data} />
              </div>
            } else if (type === 'r') {
              return <div className='grid-cell' key={index}>
                <RecommendationBoxContainer
                  editMode={editMode}
                  recommendation={data} />
              </div>
            } else if (type === 'p') {
              return <div className={`grid-cell ${editMode ? 'no-shadow faded' : ''}`} key={index}>
                <PlannedShotBoxContainer
                  clickDisabled={editMode}
                  shot={data} />
              </div>
            } else return null
          })
        }
        {editMode
          ? <RecommendationAdditionBoxContainer />
          : null
        }
      </div>
      : <div>
        {editMode
          ? <RecommendationAdditionBoxContainer />
          : <h4>{translate('noImmunizations')}</h4>
        }
      </div>
    }
    <hr />
  </div>
}

ShotVirtualContainer.propTypes = {
  patientBirthDate: PropTypes.string.isRequired,
  immunizations: PropTypes.array,
  planned: PropTypes.array,
  recommendations: PropTypes.array
}

export default withPolyglot(ShotVirtualContainer, 'pathologiesGrid')
